var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"inner-wrapper",domProps:{"innerHTML":_vm._s(_vm.rules)}},[_vm._v("活动规则")])])}
var staticRenderFns = []

export { render, staticRenderFns }